<template>
    <div class="main-background">
        <div class="main-wish-products-container">
            <div v-for="product of wishList" :key="product.id" class="wish-product-item" @click="setClickToProduct(product)">
               <img :src="product.img" :alt="product.name" class="wish-product-image" /> 
            <button :class="`product-wish-button ${wishList.find(el => el.id === product.id) && 'product-wish-includes'}`" @click.stop="onToogleWishList(product)">
              <heart-icon class="product-wish-icon"/>
             </button>
             <p class="wish-product-name">{{ product.name.length > 50 ? product.name.substring(0, 50) + '...' : product.name }}</p>
             <!-- <p class="wish-product-price">{{ `${product.price} грн.` }}</p> -->
             <p class="wish-product-stars-raiting">
                <star-icon class="wish-product-stars-raiting-icon"/>
                {{ product.stars }}
              </p>
            </div>
        </div>
        <div v-if="!wishList.length" class="wish-null-product-container">
              <p class="wish-null-product-text">Мій список порожній</p>
            </div>
    </div>
</template>

<script>

import { HeartIcon, StarIcon } from 'vue-feather-icons'
import { mapMutations } from "vuex"

export default {
    name: "product-page",
    components: {
        HeartIcon,
        StarIcon
    },
    props: {

    },
    data() {
        return {
            usedCategories: {},
            categoryItems: [],
            productItemsElements: [],
            searchLocalText: '',
            isOpenSortList: false,
            usedSort: '',
            sortList: [
                {id: 1, name: 'А-Я', value: 'name'},
                {id:2, name: 'Я-А', value: '-name'},
                {id: 3, name: 'Зростанням ціни', value: 'price'},
                { id: 4, name: 'Спаданням ціни', value: '-price'},
            ]
        }
    },
    async mounted() {
        window.scrollTo(0, 0);
        this.searchLocalText = this.getSearchText
    },
    computed: {
      isShowProducts() {
         return this.$store.getters.isShowProducts
      },
      preCategories() {
         return this.$store.getters.preCategories
      },
      getProducts() {
         return this.$store.getters.getProducts
      },
       getSearchText() {
            return this.$store.getters.getSearchText
      },
      getFilterParametrs() {
        return this.$store.getters.getFilterParametrs
      },
      getCheckedCategory() {
        return this.$store.getters.getCheckedCategory
      },
      wishList() {
        return this.$store.getters.wishList
      }
    },
    methods: {
      ...mapMutations(['setIsShowProducts', 'setIsOpenProductInfo', 'setAddPerCategory', 'setChangeSearchText', 'addPerPage', 'setCheckedCategory', 'addToWishList']),
    onToogleWishList(value) {
      this.addToWishList(value)
    },  
    setClickToProduct(value) {
      this.setIsOpenProductInfo(value);
      this.addPerPage("product");
      this.$emit("setIsChangePage", "productInfo");
    },
      activeProductSearch () {
            if (this.searchLocalText.length < 3) {
                return
            }
            try {
                let data = {
                    q: this.searchLocalText,
                    category_ids: null,
                    price_from: 0,
                    price_to: 999999
                }
                this.$store.dispatch('searchedProducts', data)
                this.$emit('setIsChangePage', 'product')
            } catch (error) {
                console.log(error.message)
            }
        },
      goToMainPage() {
            this.setChangeSearchText('')
            this.$emit('setIsChangePage', 'home')
        },
    isStartSort(sort) {
        this.usedSort = sort.name
        this.isOpenSortList = false
        let data
        if (this.getCheckedCategory && this.isShowProducts === 'products' && !this.getFilterParametrs?.category_ids) {
            data = {
              category_ids: [this.getCheckedCategory.id],
              price_from: 0,
              price_to: 99999,
              sort: sort.value 
            }
        }
        if (this.getFilterParametrs?.category_ids) {
            data = {
              ...this.getFilterParametrs,
              sort: sort.value  
            }
        }
        if (!this.getCheckedCategory && !this.getFilterParametrs?.category_ids && this.getFilterParametrs.price_to) {
            data = {
                    ...this.getFilterParametrs,
                    sort: sort.value
                } 
        }
       this.$store.dispatch('searchedProducts', data)
    },

    setIsOpenFilterPage() {
        this.addPerPage('product')
        this.$emit('setIsChangePage', 'filter')
    },

    setClickToHeaderCategory(value) {
        try {
                this.$store.dispatch('getProductsReq', value.id)
            } catch (error) {
                console.log(error.message)
            } 
    },

    setClickToCategory(value) {
         if (value?.children) {
            this.usedCategories = value
            this.setAddPerCategory(value.children)
            this.setIsShowProducts('preCategory')
         } else {
            try {
               this.$store.dispatch('getProductsReq', value.id)
            } catch (error) {
               console.log(error.message)
            }
         }
        },
        getFilterCounter(value) {
            let counter = value.category_ids?.length || 0
            return (Object.keys(value)?.length - 1) + counter
        },
        setClickToPreCategories(value) {
            this.setCheckedCategory(value)
         this.$store.dispatch('getProductsReq', value.id)
        },

        setIsOpenSortList() {
            this.isOpenSortList = !this.isOpenSortList
        }
    },
    watch: {
        searchLocalText(newValue, oldValue) {
            let val = oldValue
            val
            if (!newValue.length) {
                if (!this.getCheckedCategory) {
                    this.$emit('setIsChangePage', 'home')
                } else {
                    this.setIsShowProducts('category')
                }
            }
                this.setChangeSearchText(newValue)
                this.activeProductSearch()
           
        },
        preCategories(newValue, oldValue) {
            let val = oldValue
            val
            this.usedCategories = newValue
        },
    }
}
</script>

<style scoped>
.main-background {
    background: #121212;
    padding: 16px;
}

.filter-category-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  width: 100%;
  margin-top: 16px;
}
.filter-category-item {
  border-radius: 16px;
  border: 1px solid #b5b9bf;
  color: #333;
  text-align: center;
  font-family: Inter;
  font-size: 10px;
  font-weight: 600;
  line-height: 18px;
  background: #fff;
  padding: 7px 10px;
  cursor: pointer;
}

.main-wish-products-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;  
}

.wish-product-item {
    display: block;
    position: relative;
    width: 170px;
    margin: 0 auto;
}

.wish-product-image {
    border-radius: 5px;
    width: 100%;
    height: 120px;
    object-fit: cover;
    object-position: center;
}

.product-wish-button {
  position: absolute;
  top: 4px;
  right: 4px;
  width: 28px;
  height: 28px;
  background: #1D1D1D;
  border: none;
  padding: 6px;
  border-radius: 50%;
}
.product-wish-icon {
  display: block;
  color: #A0A0A0;
  width: 15px;
  height: 15px;
}

.product-wish-includes .product-wish-icon {
  color: #1E7CE9;
  fill: #1E7CE9;
}

.wish-product-name {
    color: #FFF;
    font-family: 'Comfortaa', sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 18px; 
    margin-top: 12px;
    height: 54px;
}
.wish-product-stars-raiting {
  color: #A0A0A0;
  font-family: 'Comfortaa', sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  margin-top: 12px;
  text-align: end;
}

.wish-product-stars-raiting-icon {
    fill: #1E7CE9;
    color: #1E7CE9;
    width: 16px;
    height: 16px;
    vertical-align: -3px;
}

.wish-null-product-container {
  width: 100%;
  padding-top: 100px;
}

.wish-null-product-text {
  text-align: center;
  color: #A0A0A0;
  font-family: 'Comfortaa', sans-serif;
  font-size: 20px;
  font-weight: 500;
  line-height: 16px;
}

</style>